<template>
  <div class="star-chart">
    <img :src="skyMapUrl" class="image" alt="Sky map" />
    <div class="overlay">
      <RouterLink
        v-for="(session, i) in sessions"
        :key="session.id"
        :to="`/astronomers/${session.astronomer.slug}/targets/${session.target.id}`"
        :style="{ zIndex: sessions.length - i }"
      >
        <div
          class="session-pin"
          :class="{ 'no-avatar': !session.astronomer.avatar_url }"
          :title="`${session.astronomer.username} - ${session.target.name}`"
          :style="pinStyle(session.target.ra, session.target.dec)"
        >
          <img
            v-if="session.astronomer.avatar_url"
            :src="session.astronomer.avatar_url"
            class="avatar-pin"
            :alt="session.astronomer.username"
          />
        </div>
      </RouterLink>

      <div
        v-if="moon"
        class="session-pin moon"
        title="moon"
        :style="pinStyle(moon.ra, moon.dec)"
      >
        <img :src="moonUrl" class="avatar-pin" alt="moon" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import skyMapUrl from '../../images/sky-map.jpg'
import moonUrl from '../../images/moon.png'

interface Target {
  id: number
  name: string
  ra: number | null
  dec: number | null
}

interface Astronomer {
  username: string
  avatar_url: string | null
  slug: string
}

interface Session {
  id: number
  target: Target
  astronomer: Astronomer
}

interface MoonPosition {
  ra: number
  dec: number
}

defineProps<{
  sessions: Session[]
  moon: MoonPosition | null
}>()

function pinStyle(ra: number | null, dec: number | null): Record<string, string> {
  if (ra == null || dec == null) return { display: 'none' }
  const left = (360 - ra) / 360 * 100
  const bottom = (dec + 90) / 180 * 100
  return { bottom: `${bottom}%`, left: `${left}%` }
}
</script>

<style scoped>
.star-chart {
  position: relative;
}

.image {
  display: block;
  width: 100%;
}

.overlay {
  position: absolute;
  inset: 0;
}

.session-pin {
  position: absolute;
  width: 30px;
  height: 30px;
  margin-left: -13px;
  margin-bottom: -9px;
}

.session-pin.moon {
  border-radius: 9999px;
  box-shadow: 0 0 20px 5px #fff;
}

.avatar-pin {
  border-radius: 9999px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
